import { useQuery } from '@tanstack/react-query';
import type { AgentApiAllianceAgentsIndex } from '@/types/serializers';

interface FetchAllianceAgentsParams {
  page?: number;
}

export const ALLIANCE_AGENTS_QUERY_KEY = ['alliance_agents'] as const;

export default function useFetchAllianceAgents(params?: FetchAllianceAgentsParams) {
  return useQuery({
    queryKey: [...ALLIANCE_AGENTS_QUERY_KEY, params?.page ?? 1],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (params?.page) searchParams.set('page', String(params.page));
      const queryString = searchParams.toString();
      const response = await fetch(
        `/agent/api/alliance_agents${queryString ? `?${queryString}` : ''}`
      );
      if (!response.ok) {
        throw new Error('エージェント一覧の取得に失敗しました');
      }
      const data: AgentApiAllianceAgentsIndex = await response.json();
      return data;
    },
  });
}
